import Vue from 'vue'
import Vuex from 'vuex'
// 导入 user 操作的文件  按所有的导入存在浏览器中
import * as Author from './utils/author'

Vue.use(Vuex)
// 使用vue登录

export default new Vuex.Store({
  state: {
    title: '工作台',
    user: Author.getAuthor(),
    once: true,
    restState: false,
    holdText: '保持',
    statusDic: '',
    outCall: 0,
    stateId: '',
    selectOrgId: '',
    selectUnionOrgId: '',
    isFull: false,
    centerFull: false,
    centerPhone: '',
    current: 'CcHome',
    orgPhoto: '',
    id: 0,
    orgId: 0,
    orgName:'',
    orgAreaLevel: 0,
    orgAreaName: '',
    baseInfoId: '',
    partyOrgId: '',
    searchlist: {},
    orgLevel: '',
    menu: [],
    path: ['/login', '/index', '/home'],
    permission: [],
    name: '',
    seatNo: '',
    info: function() {
      let infodata = localStorage.getItem('czUserInfo')
      try {
        if (infodata) {
          infodata = JSON.parse(localStorage.getItem('czUserInfo'))
        }

      } catch (error) {
        infodata = {}
      }
      return infodata
    }
  },

  mutations: {
    setUser(state, user) {
      // 将 token 保存到 storage 中
      Author.setAuthor(user)
      // 将 token 缓存 到 user 中
      state.user = user

    },
    current(state, data) {
      state.current = data
    },
    restState(state, data) {
      state.restState = data
    },
    statusDic(state, data) {
      state.statusDic = data
    },
    holdText(state, data) {
      state.holdText = data
    },

    outCall(state, data) {
      state.outCall = data
    },
    stateId(state, data) {
      state.stateId = data
    },

    getPhone(state, data) {
      state.centerPhone = data

    },
    setOnce(context, msg) {
      // context.custid = msg;
      context.once = false
    },
    setId(state, id) {
      state.id = id
    },
    orgId(state, orgId) {
      state.orgId = orgId
    },
    orgName(state,name){
      state.orgName = name
    },
    orgAreaLevel(state, orgAreaLevel) {
      state.orgAreaLevel = orgAreaLevel
    },
    orgAreaName(state, orgAreaName) {
      state.orgAreaName = orgAreaName
    },
    setBaseInfoId(state, id) {
      state.baseInfoId = id
    },
    setPartyOrgId(state, id) {
      state.partyOrgId = id
    },
    setMenu(state, menu) {
      state.menu = menu
    },
    setPath(state, path) {
      state.path = path
    },
    setPermission(state, permission) {
      state.permission = permission
    },
    setSelectOrgId(state, selectOrgId) {
      state.selectOrgId = selectOrgId
    },
    setSelectUnionOrgId(state, selectUnionOrgId) {
      state.selectUnionOrgId = selectUnionOrgId
    },
    setNo(state, seatNo) {
      state.seatNo = seatNo
    },
    isFull(state, data) {
      state.isFull = data
    },
    centerFull(state, data) {
      state.centerFull = data
    },

    setInfo(state, info) {
      state.info = info
      state.orgLevel = info.orgLevel
      localStorage.setItem('czUserInfo', JSON.stringify(info))
    }
  },
  actions: {
    setPhone({ commit, state }, name) {
      commit('getPhone', name)
    },
    logout({  commit, state }) {
      commit('setId', 0)
      commit('orgId', 0)
      commit('orgName', '')
      commit('orgAreaLevel', 0)
      commit('orgAreaName', '')
      commit('setBaseInfoId', null)
      commit('setPartyOrgId', '')
      commit('setMenu', [])
      commit('setPath', ['/login', '/index', '/home'])
      commit('setPermission', [])
      commit('setInfo', {})
      commit('centerPhone', null)
      commit('setNo', null)
      commit('restState', null)
      commit('statusDic', null)
      commit('outCall', null)
      commit('stateId', null)
      commit('holdText', null)
      commit('centerFull', null)
      commit('isFull', null)

      localStorage.removeItem('czUserInfo')
    }
  },
  getters: {
    current: state => state.current,
    centerPhone: state => state.centerPhone
  }
})
